import React, { useState } from 'react'
import { StyledContainer, StyledHelperText, StyledLabel, StyledTextarea } from './TextArea.styled'

const TextArea = ({ label = '', value, ...props }) => {
  const [focused, setFocused] = useState(false)
  const isFocusedOrFilled = focused || value?.length > 0

  return (
    <StyledContainer>
      <StyledLabel isFocusedOrFilled={isFocusedOrFilled}>{label}</StyledLabel>
      <StyledTextarea
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        value={value}
        {...props}
      />
      <StyledHelperText>
        <span>
          {value?.length || 0}/{props.maxLength}
        </span>
      </StyledHelperText>
    </StyledContainer>
  )
}

export default TextArea
